<template>
  <section class="resume-section" id="experience">
    <div class="resume-section-content">
      <h2 class="mb-5">{{ experience }}</h2>

      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">
            <i class="fab fa-reddit text-danger me-2"></i> {{ redditDetails.title }}
          </h3>
          <div class="subheading mb-0">{{ redditDetails.role }}</div>
          <div class="mb-3">{{ redditDetails.location }}</div>
          <ul class="list-unstyled">
            <li v-for="(detail, index) in redditDetails.details" :key="'reddit-' + index">
              <i class="fas fa-code text-primary me-2"></i> {{ detail }}
            </li>
          </ul>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">{{ redditDetails.duration }}</span></div>
      </div>

      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">
            <i class="fab fa-amazon text-warning me-2"></i> {{ amazonDetails.title }}
          </h3>
          <div class="subheading mb-0">{{ amazonDetails.role }}</div>
          <div class="mb-3">{{ amazonDetails.location }}</div>
          <ul class="list-unstyled">
            <li v-for="(detail, index) in amazonDetails.details" :key="'amazon-' + index">
              <i class="fas fa-code text-primary me-2"></i> {{ detail }}
            </li>
          </ul>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">{{ amazonDetails.duration }}</span></div>
      </div>

      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">{{ peergroupDetails.title }}</h3>
          <div class="subheading mb-0">{{ peergroupDetails.role }}</div>
          <div class="mb-3">{{ peergroupDetails.location }}</div>
          <ul class="list-unstyled">
            <li v-for="(detail, index) in peergroupDetails.details" :key="'peergroup-' + index">
              <i class="fas fa-code text-primary me-2"></i> {{ detail }}
            </li>
          </ul>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">{{ peergroupDetails.duration }}</span></div>
      </div>

      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">{{ adpDetails.title }}</h3>
          <div class="subheading mb-0">{{ adpDetails.role }}</div>
          <div class="mb-3">{{ adpDetails.location }}</div>
          <ul class="list-unstyled">
            <li v-for="(detail, index) in adpDetails.details" :key="'adp-' + index">
              <i class="fas fa-code text-primary me-2"></i> {{ detail }}
            </li>
          </ul>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">{{ adpDetails.duration }}</span></div>
      </div>

      <div class="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div class="flex-grow-1">
          <h3 class="mb-0">{{ navCanadaDetails.title }}</h3>
          <div class="subheading mb-0">{{ navCanadaDetails.role }}</div>
          <div class="mb-3">{{ navCanadaDetails.location }}</div>
          <ul class="list-unstyled">
            <li v-for="(detail, index) in navCanadaDetails.details" :key="'navCanada-' + index">
              <i class="fas fa-code text-primary me-2"></i> {{ detail }}
            </li>
          </ul>
        </div>
        <div class="flex-shrink-0"><span class="text-primary">{{ navCanadaDetails.duration }}</span></div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    redditDetails() {
      return this.$i18n.messages[this.$i18n.locale].experience.reddit;
    },
    amazonDetails() {
      return this.$i18n.messages[this.$i18n.locale].experience.amazon;
    },
    peergroupDetails() {
      return this.$i18n.messages[this.$i18n.locale].experience.peergroup;
    },
    adpDetails() {
      return this.$i18n.messages[this.$i18n.locale].experience.adp;
    },
    navCanadaDetails() {
      return this.$i18n.messages[this.$i18n.locale].experience.navCanada;
    },
    experience() {
      return this.$t('sections.experience')
    }
  }
};
</script>
